<template>
  <div id="food-settings">
    <mu-card-header
      titleClass="boldTitle largeTitle"
      :title="title"
      :subTitle="subTitle"
    ></mu-card-header>
    <mu-card-text>
      <mu-row gutter class="gutter">
        <mu-col class="likes" width="100" desktop="50" tablet="100">
          <mu-card>
            <mu-paper id="favorite-food-autocomplete">
              <mu-auto-complete
                class="inputInPaper"
                icon="search"
                :underlineShow="false"
                :scroller="scroller"
                inputClass="favoriteAutocomplete"
                :openOnFocus="!favoriteSearching"
                :fullWidth="true"
                :hintText="$t('message.searchText')"
                v-model="favoriteSearchValue"
                :maxSearchResults="10"
                :dataSource="favoriteDataSource"
                :dataSourceConfig="foodDataSourceConfig"
                :maxHeight="250"
                @change="handleFavoriteSelected"
                filter="noFilter"/>
            </mu-paper>
            <mu-list>
              <mu-sub-header>
                {{$t('message.foodPreferencesLove')}}
              </mu-sub-header>
              <mu-sub-header v-if="favorites.length === 0">
                {{$t('message.emptyText')}}
              </mu-sub-header>
              <mu-divider></mu-divider>
              <mu-list-item
                v-for="item, index in favorites"
                v-bind:class="{odd: index % 2 === 0}"
                :key="'fav-food-' + index"
                :title="item.food_name"
              >
                <mu-icon-button icon="delete" slot="right" @click.native="deleteFavorite(item)"></mu-icon-button>
              </mu-list-item>
            </mu-list>
          </mu-card>
        </mu-col>
        <mu-col class="dislikes" width="100" desktop="50" tablet="100">
          <mu-card>
            <mu-paper id="disliked-food-autocomplete">
              <mu-auto-complete
                class="inputInPaper"
                icon="search"
                :underlineShow="false"
                :scroller="scroller"
                inputClass="dislikeAutocomplete"
                :openOnFocus="!favoriteSearching"
                :fullWidth="true"
                :hintText="$t('message.searchText')"
                v-model="dislikeSearchValue"
                :maxSearchResults="10"
                :dataSource="dislikeDataSource"
                :dataSourceConfig="foodDataSourceConfig"
                :maxHeight="250"
                @change="handleDislikeSelected"
                filter="noFilter"/>
            </mu-paper>
            <mu-list>
              <mu-sub-header>
                {{$t('message.foodPreferencesHate')}}
              </mu-sub-header>
              <mu-sub-header v-if="dislikes.length === 0">
                {{$t('message.emptyText')}}
              </mu-sub-header>
              <mu-divider></mu-divider>
              <mu-list-item
                v-bind:class="{odd: index % 2 === 0}"
                v-for="item, index in dislikes"
                :key="'disliked-food-' + index"
                :title="item.food_name"
              >
                <mu-icon-button icon="delete" slot="right" @click.native="deleteDislike(item)"></mu-icon-button>
              </mu-list-item>
            </mu-list>
          </mu-card>
        </mu-col>
      </mu-row>
      <mu-raised-button
        class="large"
        :disabled="isUpdating"
        @click.native="submitForm()"
        :label="!isUpdating ? $t('message.updateText') : $t('message.updatingText')"
        fullWidth
        secondary
      ></mu-raised-button>
    </mu-card-text>
  </div>
</template>
<script>

  import UserApi from '../../api/User'
  import FoodApi from '../../api/Food'
  import ScrollerMixin from '../../mixins/ScrollerMixin'
  import {Observable} from 'rxjs/Rx'
  

  export default {
    mixins: [ScrollerMixin],
    data() {
      return {
        title: this.$t('message.foodPreferencesTitle'),
        subTitle: this.$t('message.foodPreferencesSubTitle'),
        isUpdating: false,
        foodDataSourceConfig: {
          text: "food_name",
          value: "food_id"
        },
        favoriteDataSource: [],
        favoriteSearchValue: "",
        favoriteSearching: false,
        dislikeDataSource: [],
        dislikeSearchValue: "",
        dislikeSearching: false,
        favorites: [],
        dislikes: []
      }
    },
    mounted() {
      let self = this;

      self.getDislikedFoods();
      self.getFavoriteFoods();

      const favoriteAutocompleteElement = $('.favoriteAutocomplete');
      Observable.fromEvent(favoriteAutocompleteElement, 'input').map(x => x.currentTarget.value)
        .debounceTime(250)
        .subscribe(function (eventText) {
          self.searchFoods(eventText, "favorite");
        });

      const dislikeAutocompleteElement = $('.dislikeAutocomplete');
      Observable.fromEvent(dislikeAutocompleteElement, 'input').map(x => x.currentTarget.value)
        .debounceTime(250)
        .subscribe(function (eventText) {
          self.searchFoods(eventText, "disliked");
        });

    },
    methods: {
      submitForm() {
        let self = this;
        self.isUpdating = true;
        UserApi.putFavouriteFoods(self.favorites).then(function () {
          self.getFavoriteFoods();
          UserApi.putDislikedFoods(self.dislikes).then(function () {
            self.getDislikedFoods();
            self.isUpdating = false;
            //self.$toastr.success("Updated food preferences")
          })
        });
      },
      handleFavoriteSelected(value) {
        let self = this;
        const checkExists = self.favorites.filter(function (item) {
          return item.food_name === value;
        });
        if (checkExists.length === 0) {
          const currentFavorite = self.favoriteDataSource.filter(function (item) {
            return item.food_name === value;
          })[0];
          self.favorites.push(currentFavorite);
          self.favoriteSearchValue = "";
          self.favoriteDataSource = [];
          UserApi.putFavouriteFoods(self.favorites).then(function (response) {
            //self.$toastr.success("Added " + currentFavorite.food_name + " as a favorite");
          });
        }
      },
      handleDislikeSelected(value) {
        let self = this;
        const checkExists = self.dislikes.filter(function (item) {
          return item.food_name === value;
        });
        if (checkExists.length === 0) {
          const currentDislike = self.dislikeDataSource.filter(function (item) {
            return item.food_name === value;
          })[0];
          self.dislikes.push(currentDislike);
          self.dislikeSearchValue = "";
          self.dislikeDataSource = [];
          UserApi.putDislikedFoods(self.dislikes).then(function (response) {
            //self.$toastr.success("Added " + currentDislike.food_name + " as a dislike");
          });
        }
      },
      deleteFavorite(item) {
        let self = this;
        const index = self.favorites.indexOf(item);
        self.favorites.splice(index, 1);
        UserApi.putFavouriteFoods(self.favorites);
      },
      deleteDislike(item) {
        let self = this;
        const index = self.dislikes.indexOf(item);
        self.dislikes.splice(index, 1);
        UserApi.putDislikedFoods(self.dislikes);
      },
      getFavoriteFoods() {
        let self = this;
        UserApi.getFavouriteFoods()
          .then(function (response) {
            self.favorites = response.data;
          })
      },
      getDislikedFoods() {
        let self = this;
        UserApi.getDislikedFoods()
          .then(function (response) {
            self.dislikes = response.data;
          })
      },
      /**
       * Search for a food and the array to populate 'favorite' or 'disliked'
       * @param eventText
       * @param to
       */
      searchFoods(eventText, to = "favorite") {
        let self = this;


        FoodApi.autoComplete(eventText)
          .then(function (response) {

            let items = [];
            let foods = [];
            let itemLength = response.data.length;

            if (_.isArray(response.data)) {
              for (let i = 0; i < itemLength; i++) {
                let model = {
                  food_id: 0,
                  food_name: response.data[i]
                };
                items.push(model);
              }
              foods = items;
              self.$nextTick(function () {
                foods = items.sort(function (a, b) {
                  return a.food_name.toLowerCase() > eventText.toLowerCase()
                });
                if (to === "favorite") {
                  self.favoriteDataSource = foods;
                }
                if (to === "disliked") {
                  self.dislikeDataSource = foods;
                }
              });
            }
          });


      }
    }
  }
</script>
<style lang="less">
  #food-settings {
    .inputInPaper .mu-text-field {
      margin-bottom: 0;
      .mu-text-field-content {
        padding-top: 8px;
      }
    }
  }

  @media (min-width: 993px) {
    #food-settings .row.gutter .desktop-50 {
      width: 49%;
    }
  }
</style>



// WEBPACK FOOTER //
// Food.vue?24c2a267